module.exports = __webpack_public_path__ + "img/login_bg.321ed9d0.jpg";